<div class="main-block">

  <div class="h-full flex-auto sm:p-0 overflow-y-auto" data-testId="askForLangBoxContainer">
    <div class="flex h-full flex-col justify-center items-center content-center">
      <div class="flex min-w-80">

        <fuse-card class="flex flex-col items-center w-full p-8 filter-info bg-white">
          <h2 class="text-center mb-4">Please select your language / Veuillez choisir votre langue.</h2>
          
          <mat-spinner *ngIf="(langsListParamsService.waitingForAvailableLang$|async)"></mat-spinner>

          <ng-container *ngFor="let lang of (langsListParamsService.availableLangs$|async)">

            <button
              class="mb-2 w-full"
              mat-stroked-button
              (click)="setActiveLang(lang.id)">

              <span class="flex items-center justify-center">
                <span>{{lang.label}}</span>
              </span>

            </button>
          </ng-container>

        </fuse-card>

      </div>
    </div>
  </div>

</div>
